import React, { useCallback, useEffect, useRef, useState } from 'react';
import Scene from '../components/Scene';
import Login from '../components/Login';
import Register from '../components/Register';
import Customization from '../components/Customization';
import ForgetPassword from '../components/ForgetPassword';
import ResetPassword from '../components/ResetPassword';
// import Vision from '../components/Vision';
import Quiz from '../components/Quiz';
import Layout from '../components/Layout';
import { useHistory } from 'react-router-dom';
import {
  getProfile,
  resetPassword,
  setNewPassword,
  signIn,
  submit,
} from '../services/Authentication';
import { auth } from 'common/firebase';
const state = {
  AUTHORIZING: 0,
  LOGIN: 1,
  REGISTER: 2,
  SELECT_GENDER: 3,
  CUSTOMIZE: 5,
  GAME: 6,
  FORGET_PASSWORD: 7,
  RESET_PASSWORD: 8,
  QUIZ: 9,
};
const Game = () => {
  const params = new URLSearchParams(window.location.search);
  const action = params.get('action');
  const token = params.get('token');
  const history = useHistory();
  const [gameState, setGameState] = useState(state.AUTHORIZING);
  const [loading, setLoading] = useState(false);
  const [scale, setScale] = useState(window.innerWidth / 1280);
  const [name, setName] = useState('');
  const delayedCalculateScale = useCallback(
    () => setTimeout(() => calculateScale(), 1000),
    []
  );
  //#region Ref variables
  const tokenRef = useRef(null);
  const gameFrame = useRef(null);
  const resetPasswordRef = useRef(null);
  const loginRef = useRef(null);
  const forgetPasswordRef = useRef(null);
  const registerRef = useRef(null);
  //#endregion

  const setGameToMainMenu = useCallback((payload) => {
    setGameState(state.GAME);
    postMessageToFrame(gameFrame, {
      type: 'SET_DATA',
      payload: {
        profile: payload.profile,
        stageProgress: payload.stageProgress,
      },
    });
    postMessageToFrame(gameFrame, {
      type: 'CHANGE_STATE',
      payload: 'mainMenu',
    });
  }, []);
  const updateToken = useCallback(async (customToken) => {
    tokenRef.current = {
      token: await auth.currentUser.getIdToken(),
      customToken: customToken,
    };
    postMessageToFrame(gameFrame, {
      type: 'UPDATE_TOKEN',
      payload: tokenRef.current.token,
    });
  }, []);
  const initAccount = useCallback(
    async (payload) => {
      await updateToken(payload.customToken);
      if (!payload.initialized) {
        auth.signOut();
        setGameState(state.REGISTER);
        postMessageToFrame(gameFrame, {
          type: 'CHANGE_STATE',
          payload: 'register',
        });
      } else {
        if (payload.profile) {
          setGameToMainMenu(payload);
        } else {
          auth.signOut();
          setGameState(state.SELECT_GENDER);
          postMessageToFrame(gameFrame, {
            type: 'CHANGE_STATE',
            payload: 'customize',
          });
        }
      }
    },
    [setGameToMainMenu, updateToken]
  );
  const authorize = useCallback(async () => {
    //This function use one time only then need to unsubscribe after used for protect duplicate request to server.
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const payload = await getProfile();
        initAccount(payload);
      } else {
        postMessageToFrame(gameFrame, {
          type: 'CHANGE_STATE',
          payload: 'login',
        });
        setGameState(state.LOGIN);
      }
      unsubscribe();
    });
  }, [initAccount]);
  const handleMessage = useCallback(
    async (e) => {
      switch (e.data.type) {
        case 'LOADED':
          if (action === 'reset') {
            setGameState(state.RESET_PASSWORD);
            postMessageToFrame(gameFrame, {
              type: 'CHANGE_STATE',
              payload: 'login',
            });
          } else {
            setGameState(state.AUTHORIZING);
            authorize();
          }
          break;
        case 'CHANGE_STATE':
          if (Object.keys(state).some((v) => v === e.data.payload)) {
            setGameState(state[e.data.payload]);
          } else {
            throw new Error(
              `Not found state ${e.data.payload} in state of function SET_STATE`
            );
          }
          break;
        case 'LOGIN':
          await auth.signInWithCustomToken(`${tokenRef.current.customToken}`);
          updateToken(tokenRef.current.customToken);
          break;
        case 'LOGOUT':
          auth.signOut();
          postMessageToFrame(gameFrame, {
            type: 'CHANGE_STATE',
            payload: 'login',
          });
          setName('');
          setGameState(state.LOGIN);
          break;
        default:
          break;
      }
    },
    [action, authorize, updateToken]
  );
  const calculateScale = () => {
    setScale(window.innerWidth / 1280);
  };
  useEffect(() => {
    window.addEventListener('resize', delayedCalculateScale);
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      window.removeEventListener('resize', delayedCalculateScale);
    };
  }, [delayedCalculateScale, handleMessage]);

  const postMessageToFrame = (frameRef, value) => {
    frameRef.current.contentWindow.postMessage(value, '*');
  };

  const handleLoginSubmit = async (form) => {
    setLoading(true);
    loginRef.current.setError('');
    const payload = await signIn(form.username, form.password);
    if (!payload.error) {
      await initAccount(payload);
    } else {
      loginRef.current.setError(payload.error);
    }
    setLoading(false);
  };
  const handleClickResetPassword = () => {
    setGameState(state.FORGET_PASSWORD);
  };
  const handleSubmitSetNewPassword = async (password) => {
    setLoading(true);
    resetPasswordRef.current.setError('');
    const payload = await setNewPassword(token, password);
    setLoading(false);
    if (!payload.error) {
      resetPasswordRef.current.sendSuccess();
    } else {
      console.error(payload.error);
      resetPasswordRef.current.setError(payload.error);
    }
  };
  const handleBackToLoginAfterSetNewPassword = () => {
    auth.signOut();
    history.push('/');
    setGameState(state.LOGIN);
  };
  const handleRegisterSubmit = async (form) => {
    setLoading(true);
    registerRef.current.setError('');
    const payload = await submit(
      form.password,
      form.email,
      tokenRef.current.token
    );
    setLoading(false);
    if (!payload.error) {
      setGameState(state.SELECT_GENDER);
      postMessageToFrame(gameFrame, {
        type: 'CHANGE_STATE',
        payload: 'customize',
      });
    } else {
      registerRef.current.setError(payload.error);
      console.error(payload.error);
    }
  };
  const handleCustomizeSubmit = (name) => {
    setName(name);
    setGameState(state.CUSTOMIZE);
    postMessageToFrame(gameFrame, { type: 'SET_NAME', payload: name });
  };
  const handleForgetPasswordSubmit = async (email) => {
    setLoading(true);
    forgetPasswordRef.current.setError('');
    const payload = await resetPassword(email);
    setLoading(false);
    if (!payload.error) {
      console.log(payload);
      forgetPasswordRef.current.sendSuccess();
    } else {
      forgetPasswordRef.current.setError(payload.error);
    }
  };
  const handleCloseQuiz = (score) => {
    setGameState(gameState.GAME);
    console.log(score);
    postMessageToFrame(gameFrame, {
      type: 'SUBMIT_SCORE',
      payload: {
        score: score,
      },
    });
  };
  const content =
    gameState === state.LOGIN ? (
      <Login
        ref={loginRef}
        onSubmit={handleLoginSubmit}
        scale={scale}
        loading={loading}
        onReset={handleClickResetPassword}
      />
    ) : gameState === state.REGISTER ? (
      <Register
        ref={registerRef}
        onSubmit={handleRegisterSubmit}
        scale={scale}
        loading={loading}
      />
    ) : gameState === state.SELECT_GENDER ? (
      <Customization
        onSubmit={handleCustomizeSubmit}
        scale={scale}
        name={name}
      />
    ) : gameState === state.FORGET_PASSWORD ? (
      <ForgetPassword
        ref={forgetPasswordRef}
        scale={scale}
        loading={loading}
        onSubmit={handleForgetPasswordSubmit}
        onBack={() => setGameState(state.LOGIN)}
      />
    ) : gameState === state.RESET_PASSWORD ? (
      <ResetPassword
        ref={resetPasswordRef}
        onSubmit={handleSubmitSetNewPassword}
        scale={scale}
        loading={loading}
        onBackToLogin={handleBackToLoginAfterSetNewPassword}
      />
    ) : (
      <> </>
    );
  return (
    <>
      <Scene name="game" frame={gameFrame} />
      <Layout>{content}</Layout>
      {gameState === state.QUIZ && <Quiz onClose={handleCloseQuiz} />}
    </>
  );
};
export default Game;
